import React from 'react';

import styles from './FinanceDurationPDP.module.scss';
import { OptionSelector } from '@base-components/OptionSelector/OptionSelector';
import { usePlanData } from '../../../../hooks/usePlanData';
import { Offer, OfferItemPricing } from '../../../../../../types/offer.types';
import { Image } from '../../../../../../components/Image/Image';

interface FinanceDurationPDPProps {
  title: string;
  info?: string;
  partner?: string;
  icon?: string;
  handlePricingChange: (pricing: OfferItemPricing) => void;
  selectedFinancePricing: OfferItemPricing | null;
}

export const FinanceDurationPDP = ({
  title,
  info,
  partner,
  icon,
  handlePricingChange,
  selectedFinancePricing,
}: FinanceDurationPDPProps) => {
  const { offer } = usePlanData();
  const mainItem = offer.offerItems.find(item => item.type === 'main');
  const availablePricings = mainItem.pricings.filter(pricing => pricing.isAvailable);
  const filteredPricings = availablePricings
    .filter((pricing, index, self) => self.findIndex(p => p.months === pricing.months) === index)
    .sort((a, b) => a.months - b.months);

  const showAdditionalInfo = info && partner && icon;

  return (
    <>
      <div className={styles.separator}></div>

      <div className={styles.textContainer}>
        <div className={styles.title}>{title}</div>
        {showAdditionalInfo && (
          <>
            <div className={styles.info}>{info}</div>
            <div className={styles.icon}>
              <Image image={icon} />
            </div>
          </>
        )}
      </div>

      <OptionSelector<OfferItemPricing>
        options={filteredPricings}
        handleChange={handlePricingChange}
        selectedOption={selectedFinancePricing}
        contractType={mainItem.contractType}
      />
    </>
  );
};
